import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@features/auth/services/auth.service';
import { Observable } from 'rxjs';

/**
 * Interceptor que agrega el token de autenticación a las peticiones HTTP.
 * El manejo de errores 401 (refresh / logout) lo delega a HttpErrorsInterceptor.
 */
export function AuthInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const token = inject(AuthService).token;

  if (!token) return next(req);

  return next(
    req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }),
  );
}
